<template>
  <div class="perfil-container">
    <HomeInicio />
    <div class="card-perfil">
      <div class="card-header">
        <h2 class="card-title">Mi Perfil</h2>
        <div>
          <button v-if="!editMode" class="btn-outline" @click="activarEdicion">Editar</button>
          <button v-else class="btn-outline" @click="guardarConAnimacion">Guardar Cambios</button>
        </div>
      </div>

      <div class="tipo-evento" v-if="!editMode">
        {{ festejada.tipo_evento.toUpperCase() }}
      </div>

      <div class="perfil-body">
        <div
          class="info-item"
          v-for="(valor, key) in camposVisibles"
          :key="key"
          :ref="el => registrarInput(el, key)"
        >
          <strong>{{ key }}:</strong>
          <template v-if="!editMode">
            <span :class="key === 'Nombre' ? 'fuente-mayonice' : ''">{{ valor }}</span>
          </template>
          <template v-else>
            <input
              v-model="festejada[campos[key]]"
              :type="key === 'Fecha del Evento' ? 'date' : 'text'"
              class="input-editar animado"
            />
          </template>
        </div>

        <div class="info-item">
          <strong>Paquete:</strong> {{ festejada.paquete }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeInicio from "@/components/HomeInicio.vue";
import baseUrl from '../api';
import Swal from 'sweetalert2';
import gsap from 'gsap';

export default {
  name: "EditarFestejada",
  components: { HomeInicio },
  data() {
    return {
      festejada: {
        nombre_festejada: "", apellido_festejada: "", fechaevento: "",
        telefono: "", estado: "", paquete: "", nombre_pagina: "", correo_electronico: "", tipo_evento: ""
      },
      editMode: false,
      campos: {
        Nombre: "nombre_festejada",
        Apellido: "apellido_festejada",
        "Fecha del Evento": "fechaevento",
        Teléfono: "telefono",
        Estado: "estado",
        "Correo Electrónico": "correo_electronico",
      },
      inputRefs: {},
    };
  },
  computed: {
    camposVisibles() {
      const visible = {};
      for (const key in this.campos) {
        visible[key] = this.festejada[this.campos[key]];
      }
      return visible;
    }
  },
  mounted() {
    this.obtenerDatosFestejada();
  },
  methods: {
    registrarInput(el, key) {
      if (el) this.inputRefs[key] = el;
    },
    activarEdicion() {
      this.editMode = true;
      this.$nextTick(() => {
        for (const key in this.inputRefs) {
          const input = this.inputRefs[key]?.querySelector('input');
          if (input) {
            gsap.fromTo(input, 
              { opacity: 0, y: 10 },
              { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out', delay: 0.05 * Object.keys(this.inputRefs).indexOf(key) }
            );
          }
        }
      });
    },
    async guardarConAnimacion() {
      const campos = ['nombre_festejada', 'apellido_festejada', 'fechaevento', 'telefono', 'estado', 'correo_electronico'];
      for (const campo of campos) {
        if (!this.festejada[campo]) {
          return Swal.fire({ icon: 'error', title: 'Falta información', text: 'Completa todos los campos antes de guardar.' });
        }
      }

      try {
        const res = await fetch(`${baseUrl}/api2/miperfil_actualizar/${localStorage.getItem("id_festejada")}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.festejada)
        });

        if (!res.ok) throw new Error();

        // Animación de salida de inputs
        for (const key in this.inputRefs) {
          const input = this.inputRefs[key]?.querySelector('input');
          if (input) {
            gsap.to(input, {
              opacity: 0,
              y: -10,
              duration: 0.3,
              ease: "power1.in",
              delay: 0.03 * Object.keys(this.inputRefs).indexOf(key)
            });
          }
        }

        setTimeout(() => {
          this.editMode = false;
          Swal.fire({ icon: 'success', title: '¡Guardado!', text: 'Cambios aplicados correctamente.' });
        }, 300);
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Error al guardar', text: 'Ocurrió un error al actualizar los datos.' });
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    },
    async obtenerDatosFestejada() {
      const idFestejada = localStorage.getItem("id_festejada");
      try {
        const res = await fetch(`${baseUrl}/api2/miperfil/${idFestejada}`);
        const data = await res.json();
        if (data) {
          data.fechaevento = this.formatDate(data.fechaevento);
          this.festejada = data;
        }
      } catch (err) {
        console.error("Error al obtener datos:", err);
      }
    }
  }
};
</script>

<style scoped>
.perfil-container {
  margin-top: 140px;
  padding: 20px;
  display: flex;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
}

.card-perfil {
  width: 100%;
  max-width: 800px;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 14px 38px rgba(0, 0, 0, 0.08);
  padding: 2.5rem;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Playfair Display', serif;
  margin-bottom: 2rem;
}

.card-title {
  font-family: "serenety", serif;
  font-size: 46px;
  color: #4a3f42;
  font-weight: 500;

  margin-bottom: 16px;
}

.tipo-evento {
  background-color: #f5f5f5;
  color: #4a3f42;
  padding: 8px 12px;
  text-align: center;
  border-radius: 8px;
  font-weight: bold;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.perfil-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.info-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #333;
}

.info-item strong {
  color: #4a3f42;
  font-weight: 600;
  width: 120px;
  font-size: 13px;
}

.input-editar {
  flex: 1;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #ccc;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  transition: all 0.3s ease;
  background-color: white;
  box-shadow: 0 0 0 0 transparent;
}

.input-editar:focus {
  outline: none;
  border-color: #5f6770;
  box-shadow: 0 0 5px rgba(95, 103, 112, 0.4);
}

.fuente-mayonice {
  font-family: "Mayonice", cursive;
  font-size: 22px;
  color: #4a3f42;
}

.btn-outline {
  background-color: transparent;
  border: 1px solid #5f6770;
  color: #5f6770;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 13px;
  font-family: 'Playfair Display', serif;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background-color: #5f6770;
  color: white;
}

@media (max-width: 768px) {
  .card-perfil {
    padding: 1.2rem;
  }

  .card-title {
    font-size: 43px;
  }

  .info-item {
    font-size: 13px;
  }

  .info-item strong {
    font-size: 12px;
    width: auto;
  }

  .input-editar {
    font-size: 12px;
    padding: 6px 10px;
  }

  .fuente-mayonice {
    font-size: 20px;
  }
}
</style>
